export const COLUMN_SETTINGS = 'COLUMN_SETTINGS';
export const FAVORITE_PROPERTIES = 'FAVORITE_PROPERTIES';
export const CREATOR_PROPERTIES = 'CREATOR_PROPERTIES';
export const DEAL_STAGE_PROPERTIES = 'DEAL_STAGE_PROPERTIES';
export const TICKET_STAGE_PROPERTIES = 'TICKET_STAGE_PROPERTIES';